export const countryOptions = [
  {
    id: 1, description: "United States", name: "UnitedStates", zipCodeLabel: "ZipCode", mask: '#####-####',
    zipCodeRule: {
      required: true,
      regexZip: /^(\d{5}(?:-\d{4})?)$/
                    }
                },

{
  id: 2, description: "Canada", name: "Canada", zipCodeLabel: "PostalCode", mask: 'A#A #A#',
    zipCodeRule: {
    required: true,
      regexZip: /^[a-zA-Z]\d[a-zA-Z] ?\d[a-zA-Z]\d$/
  }
},
{
  id: 3, description: "Mexico", name: "Mexico", zipCodeLabel: "PostalCode", mask: '#####',
    zipCodeRule: {
    required: true,
      lengthZip: 5
  },
},
{
  id: 9, description: "United Kingdom", name: "UnitedKingdom", zipCodeLabel: "Postcode", mask: 'XXX! XXX',
    zipCodeRule: {
    required: true,
      regexZip: /^[a-zA-Z]{1,2}\d[a-zA-Z0-9]? ?\d[a-zA-Z]{2}$/
  }
},
{
  id: 101, description: "India", name: "India", zipCodeLabel: "PostalIndexNumber", mask: '######',
    zipCodeRule: {
    required: true,
      regexZip: /^(?!0)\d{6}$/ //India 6 digits does not start with 0
  }
  }];

export const countryOptionsEPIC = [

  {
    id: "AFG", name: "Afghanistan", zipCodeLabel: "PostalCode", mask: '',
      zipCodeRule: {
  required: false
}
            },

{
  id: "ALA", name: "AlandIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "ALB", name: "Albania", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "DZA", name: "Algeria", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "ASM", name: "AmericanSamoa", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "AND", name: "Andorra", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "AGO", name: "Angola", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "AIA", name: "Anguilla", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "ATA", name: "Antarctica", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "ATG", name: "AntiguaandBarbuda", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "ARG", name: "Argentina", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "ARM", name: "Armenia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "ABW", name: "Aruba", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "ASC", name: "AscensionIsland", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "AUS", name: "Australia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "AUT", name: "Austria", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "AZE", name: "Azerbaijan", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "BHS", name: "Bahamas", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "BHR", name: "Bahrain", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "BGD", name: "Bangladesh", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "BLR", name: "Barbados", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "BRB", name: "Belarus", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "BEL", name: "Belgium", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "BLZ", name: "Belize", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "BEN", name: "Benin", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "BMU", name: "Bermuda", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "BTN", name: "Bhutan", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "BOL", name: "Bolivia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "BIH", name: "BosniaandHerzegovina", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "BWA", name: "Botswana", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "BVT", name: "BouvetIsland", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "BRA", name: "Brazil", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "IOT", name: "BritishIndianOceanTerritory", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "VGB", name: "BritishVirginIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},

{
  id: "BRN", name: "BruneiDarussalam", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "BGR", name: "Bulgaria", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "BFA", name: "BurkinaFaso", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "BDI", name: "Burundi", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "KHM", name: "Cambodia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "CMR", name: "Cameroon", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "CAN", name: "Canada", zipCodeLabel: "PostalCode", mask: 'A#A #A#',
    zipCodeRule: {
    required: true,
      regexZip: /^[a-zA-Z]\d[a-zA-Z] ?\d[a-zA-Z]\d$/
  }
},
{
  id: "CPV", name: "CapeVerde", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "CYM", name: "CaymanIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "CAF", name: "CentralAfricanRepublic", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "TCD", name: "Chad", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GB2", name: "ChannelIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "CHL", name: "Chile", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "CHN", name: "China", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "CXR", name: "ChristmasIsland", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "CCK", name: "CocosIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "COL", name: "Colombia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "COM", name: "Comoros", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "COK", name: "CookIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "CRI", name: "CostaRica", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "CIV", name: "CoteDIvoire", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "HRV", name: "Croatia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "CUB", name: "Cuba", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "CYP", name: "Cyprus", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "CZE", name: "CzechRepublic", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "PRK", name: "DemocraticPeoplesRepublicofKorea", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "COD", name: "DemocraticRepublicoftheCongo", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "DNK", name: "Denmark", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "DGA", name: "DiegoGarcia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "DJI", name: "Djibouti", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "DMA", name: "Dominica", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "DOM", name: "DominicanRepublic", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "ECU", name: "Ecuador", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "EGY", name: "Egypt", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SLV", name: "ElSalvador", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GNQ", name: "EquatorialGuinea", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "ERI", name: "Eritrea", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "EST", name: "Estonia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "ETH", name: "Ethiopia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "FLK", name: "FalklandIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "FRO", name: "FaroeIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "FSM", name: "FederatedStatesofMicronesia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "FJI", name: "Fiji", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "FIN", name: "Finland", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MKD", name: "FormerYugoslavRepublicofMacedonia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "FRA", name: "France", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GUF", name: "FrenchGuiana", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "PYF", name: "FrenchPolynesia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "ATF", name: "FrenchSouthernTerritories", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GAB", name: "Gabon", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GMB", name: "Gambia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GEO", name: "Georgia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "DEU", name: "Germany", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GHA", name: "Ghana", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GIB", name: "Gibraltar", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GRC", name: "Greece", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GRL", name: "Greenland", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GRD", name: "Grenada", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GLP", name: "Guadeloupe", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GUM", name: "Guam", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GTM", name: "Guatemala", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GGY", name: "Guernsey", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GIN", name: "Guinea", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GNB", name: "GuineaBissau", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GUY", name: "Guyana", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "HTI", name: "Haiti", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "HMD", name: "HeardandMcDonaldIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "HND", name: "Honduras", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "HKG", name: "HongKong", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "HUN", name: "Hungary", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "ISL", name: "Iceland", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "IND", name: "India", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "IDN", name: "Indonesia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "IRN", name: "Iran", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "IRQ", name: "Iraq", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "IRL", name: "Ireland", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "IMN", name: "IsleofMan", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "ISR", name: "Israel", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "ITA", name: "Italy", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "JAM", name: "Jamaica", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "JPN", name: "Japan", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "JEY", name: "Jersey", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "JOR", name: "Jordan", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "KAZ", name: "Kazakhstan", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "KEN", name: "Kenya", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "KIR", name: "Kiribati", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "KWT", name: "Kuwait", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "KGZ", name: "Kyrgyzstan", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "LVA", name: "Latvia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "LBN", name: "Lebanon", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "LSO", name: "Lesotho", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "LBR", name: "Liberia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "LBY", name: "LibyanArabJamahiriya", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "LIE", name: "Liechtenstein", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "LTU", name: "Lithuania", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "LUX", name: "Luxembourg", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MAC", name: "Macau", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MDG", name: "Madagascar", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MWI", name: "Malawi", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MYS", name: "Malaysia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MDV", name: "Maldives", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MLI", name: "Mali", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MLT", name: "Malta", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MHL", name: "MarshallIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MTQ", name: "Martinique", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MRT", name: "Mauritania", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MUS", name: "Mauritius", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MYT", name: "Mayotte", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "FXX", name: "MetropolitanFrance", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MEX", name: "Mexico", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MCO", name: "Monaco", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MNG", name: "Mongolia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MNE", name: "Montenegro", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MSR", name: "Montserrat", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MAR", name: "Morocco", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MOZ", name: "Mozambique", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MMR", name: "Myanmar", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "NAM", name: "Namibia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "NRU", name: "Nauru", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "NPL", name: "Nepal", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "NLD", name: "Netherlands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "ANT", name: "NetherlandsAntilles", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "NCL", name: "NewCaledonia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "NZL", name: "NewZealand", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "NIC", name: "Nicaragua", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "NER", name: "Niger", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "NGA", name: "Nigeria", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "NIU", name: "Niue", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "NFK", name: "NorfolkIsland", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MNP", name: "NorthernMarianaIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "NOR", name: "Norway", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "OMN", name: "Oman", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "PAK", name: "Pakistan", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "PLW", name: "Palau", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "PSE", name: "PalestinianTerritories", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "PAN", name: "Panama", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "PNG", name: "PapuaNewGuinea", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "PRY", name: "Paraguay", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "LAO", name: "PeoplesDemocraticRepublicofLao", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "PER", name: "Peru", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "PHL", name: "Philippines", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "PCN", name: "Pitcairn", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "POL", name: "Poland", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "PRT", name: "Portugal", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "TWN", name: "ProvinceofChinaTaiwan", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "PRI", name: "PuertoRico", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "QAT", name: "Qatar", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "KOR", name: "RepublicofKorea", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MDA", name: "RepublicofMoldova", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "COG", name: "RepublicoftheCongo", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "REU", name: "Reunion", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "ROU", name: "Romania", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "RUS", name: "RussianFederation", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "RWA", name: "Rwanda", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "BLM", name: "SaintBarthelemy", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "KNA", name: "SaintKittsandNevis", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "LCA", name: "SaintLucia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "VCT", name: "SaintVincentandTheGrenadines", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "WSM", name: "Samoa", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SMR", name: "SanMarino", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "STP", name: "SaoTomeandPrincipe", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SAU", name: "SaudiArabia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SEN", name: "Senegal", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SRB", name: "Serbia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SYC", name: "Seychelles", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SLE", name: "SierraLeone", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SGP", name: "Singapore", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SVK", name: "Slovakia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SVN", name: "Slovenia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SLB", name: "SolomonIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SOM", name: "Somalia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "ZAF", name: "SouthAfrica", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SGS", name: "SouthGeorgiaandTheSouthSandwichIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "ESP", name: "Spain", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "LKA", name: "SriLanka", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SHN", name: "StHelena", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "MAF", name: "StMartin", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SPM", name: "StPierreandMiquelon", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SDN", name: "Sudan", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SUR", name: "Suriname", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SJM", name: "SvalbardandJanMayenIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SWZ", name: "Swaziland", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SWE", name: "Sweden", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "CHE", name: "Switzerland", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "SYR", name: "SyrianArabRepublic", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "TJK", name: "Tajikistan", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "THA", name: "Thailand", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "TMP", name: "TimorLeste", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "TGO", name: "Togo", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "TKL", name: "Tokelau", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "TON", name: "Tonga", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "TTO", name: "TrinidadandTobago", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "TUN", name: "Tunisia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "TUR", name: "Turkey", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "TKM", name: "Turkmenistan", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "TCA", name: "TurksandCaicosIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "TUV", name: "Tuvalu", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "VIR", name: "USVirginIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "UGA", name: "Uganda", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "UKR", name: "Ukraine", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "ARE", name: "UnitedArabEmirates", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "GBR", name: "UnitedKingdom", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "TZA", name: "UnitedRepublicofTanzania", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "UMI", name: "UnitedStatesMinorOutlyingIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "USA", name: "UnitedStates", zipCodeLabel: "ZipCode", mask: '#####-####',
    zipCodeRule: {
    required: true,
      regexZip: /^(\d{5}(?:-\d{4})?)$/
  }
},
{
  id: "URY", name: "Uruguay", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "UZB", name: "Uzbekistan", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "VUT", name: "Vanuatu", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "VAT", name: "VaticanCityState", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "VEN", name: "Venezuela", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "VNM", name: "Vietnam", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "WLF", name: "WallisandFutunaIslands", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "ESH", name: "WesternSahara", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "YEM", name: "Yemen", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "YUG", name: "Yugoslavia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "ZMB", name: "Zambia", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "EAZ", name: "Zanzibar", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
},
{
  id: "ZWE", name: "Zimbabwe", zipCodeLabel: "PostalCode", mask: '',
    zipCodeRule: {
    required: false
  }
}


];


export const plainPostalCodeCountries = [
  'AFG', 'ALA', 'ALB', 'DZA', 'ASM', 'AND', 'AGO', 'AIA', 'ATA', 'ATG', 'ARG', 'ARM',
  'ABW', 'ASC', 'AUS', 'AUT', 'AZE', 'BHS', 'BHR', 'BGD', 'BRB', 'BLR', 'BEL', 'BLZ',
  'BEN', 'BMU', 'BTN', 'BOL', 'BIH', 'BWA', 'BVT', 'BRA', 'IOT', 'VGB', 'BRN', 'BGR',
  'BFA', 'BDI', 'KHM', 'CMR', 'CPV', 'CYM', 'CAF', 'TCD', 'GB2', 'CHL', 'CHN', 'CXR',
  'CCK', 'COL', 'COM', 'COK', 'CRI', 'CIV', 'HRV', 'CUB', 'CYP', 'CZE', 'PRK', 'COD',
  'DNK', 'DGA', 'DJI', 'DMA', 'DOM', 'ECU', 'EGY', 'SLV', 'GNQ', 'ERI', 'EST', 'ETH',
  'FLK', 'FRO', 'FSM', 'FJI', 'FIN', 'MKD', 'FRA', 'GUF', 'PYF', 'ATF', 'GAB', 'GMB',
  'GEO', 'DEU', 'GHA', 'GIB', 'GRC', 'GRL', 'GRD', 'GLP', 'GUM', 'GTM', 'GGY', 'GIN',
  'GNB', 'GUY', 'HTI', 'HMD', 'HND', 'HKG', 'HUN', 'ISL', 'IND', 'IDN', 'IRN', 'IRQ',
  'IRL', 'IMN', 'ISR', 'ITA', 'JAM', 'JPN', 'JEY', 'JOR', 'KAZ', 'KEN', 'KIR', 'KWT',
  'KGZ', 'LVA', 'LBN', 'LSO', 'LBR', 'LBY', 'LIE', 'LTU', 'LUX', 'MAC', 'MDG', 'MWI',
  'MYS', 'MDV', 'MLI', 'MLT', 'MHL', 'MTQ', 'MRT', 'MUS', 'MYT', 'FXX', 'MEX', 'MCO',
  'MNG', 'MNE', 'MSR', 'MAR', 'MOZ', 'MMR', 'NAM', 'NRU', 'NPL', 'NLD', 'ANT', 'NCL',
  'NZL', 'NIC', 'NER', 'NGA', 'NIU', 'NFK', 'MNP', 'NOR', 'OMN', 'PAK', 'PLW', 'PSE',
  'PAN', 'PNG', 'PRY', 'LAO', 'PER', 'PHL', 'PCN', 'POL', 'PRT', 'TWN', 'PRI', 'QAT',
  'KOR', 'MDA', 'COG', 'REU', 'ROU', 'RUS', 'RWA', 'BLM', 'KNA', 'LCA', 'VCT', 'WSM',
  'SMR', 'STP', 'SAU', 'SEN', 'SRB', 'SYC', 'SLE', 'SGP', 'SVK', 'SVN', 'SLB', 'SOM',
  'ZAF', 'SGS', 'ESP', 'LKA', 'SHN', 'MAF', 'SPM', 'SDN', 'SUR', 'SJM', 'SWZ', 'SWE',
  'CHE', 'SYR', 'TJK', 'THA', 'TMP', 'TGO', 'TKL', 'TON', 'TTO', 'TUN', 'TUR', 'TKM',
  'TCA', 'TUV', 'VIR', 'UGA', 'UKR', 'ARE', 'GBR', 'TZA', 'UMI', 'URY', 'UZB', 'VUT',
  'VAT', 'VEN', 'VNM', 'WLF', 'ESH', 'YEM', 'YUG', 'ZMB', 'EAZ', 'ZWE'
];
